import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'
import { useAuth } from '@/composables/useAuth'
import { isGestor } from '@/utils/roles'
import { wireRouterSessionHandlers } from '@/router/routerBridge'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APPLICATION_PATH || '/'),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuth()

  if (!auth.initialized.value) {
    await auth.initialize()
  }

  // Public share replay — no auth required
  if (to.path.startsWith('/share/')) {
    return
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated.value) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    }
  }

  if (to.meta.requiresAdmin) {
    const usuario = auth.usuario.value
    if (!usuario || !isGestor(usuario.tipo)) {
      return { path: '/login' }
    }
  }

  if (to.meta.guest && auth.isAuthenticated.value) {
    return { path: '/admin' }
  }
})

wireRouterSessionHandlers({
  getCurrentFullPath: () => router.currentRoute.value.fullPath,
  isLoginPath: () => router.currentRoute.value.path === '/login',
  replaceToLogin: async (redirect) => {
    await router.replace({
      path: '/login',
      query: {
        redirect,
        expired: '1',
      },
    })
  },
})

if (import.meta.hot) {
  handleHotUpdate(router)
}

export default router
